import React from 'react';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { useArchiveDataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/archive';
import { ErrorLifecycle, FVError, FVErrorCode } from 'js/file_viewer/core/types/errors';
import { getFileExtension } from 'js/file_viewer/core/utils/paths';
import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
import { ARCHIVE_EXTS } from 'js/file_viewer/file_extension/extension_constants';
import { useDownloadSucceeded } from 'js/file_viewer/hooks/lifecycle_logging';
import { useRivieraTiming } from 'js/file_viewer/logging/hooks';
const AsyncPreviewArchive = asyncComponent('PreviewArchive', () => import('js/file_viewer/preview_archive/preview_archive'));
export const AsyncPreviewArchiveWithRivieraFetch = (props) => {
    const { previewKey, previewSessionId, setLocalError } = props;
    const previewData = useCurrentPreviewMetadata();
    const result = useArchiveDataQuery(previewKey, previewData);
    useDownloadSucceeded(previewSessionId, result.isSuccess);
    useRivieraTiming(result, previewKey, previewData);
    React.useEffect(() => {
        const isNestedFileArchive = previewKey.type === 'NestedArchiveFile' &&
            ARCHIVE_EXTS.includes(getFileExtension(previewKey.subpath));
        if (isNestedFileArchive) {
            setLocalError(new FVError(FVErrorCode.NestedFiletypeNotSupported, ErrorLifecycle.Render));
        }
    }, [previewKey, setLocalError]);
    return React.createElement(AsyncPreviewArchive, { ...props, archiveDataResult: result });
};
AsyncPreviewArchiveWithRivieraFetch.displayName = "AsyncPreviewArchiveWithRivieraFetch"
//# sourceMappingURL=async_preview_archive.preenvesnextjs.map
